(function () {
  if (window.freeShippingNotice) {
    window.freeShippingNotice.refresh();
    return;
  }

  var THRESHOLD_SELECTOR =
    '.amp-cart__rewards-progress-bar-tiers .amp-cart__rewards-progress-bar-tier:first-of-type .amp-cart__rewards-progress-bar-tier-trigger-label';
  var VARIANT_INPUT_SELECTOR =
    '[data-variant-select], select[name="id"], input[name="id"], .product-form_main_id';
  var lastThreshold = null;
  var domObserver = null;
  var watchedInputs = [];
  var inputObserver = null;
  var scheduled = false;

  function parseAmount(text) {
    var cleaned = String(text).replace(/[^\d.,]/g, '').trim();
    if (!cleaned) return null;

    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    var decimalSep = '';
    if (lastComma > lastDot) {
      decimalSep = ',';
    } else if (lastDot > lastComma) {
      decimalSep = '.';
    }

    var normalized = cleaned;
    if (decimalSep) {
      var otherSep = decimalSep === ',' ? '.' : ',';
      var digitsAfter = cleaned.length - cleaned.lastIndexOf(decimalSep) - 1;
      var occurrences = cleaned.split(decimalSep).length - 1;
      if (digitsAfter === 3 && occurrences === 1 && cleaned.indexOf(otherSep) === -1) {
        normalized = cleaned.split(decimalSep).join('');
      } else {
        normalized = cleaned.split(otherSep).join('').replace(decimalSep, '.');
      }
    }

    var value = parseFloat(normalized);
    return isNaN(value) ? null : value;
  }

  function readThreshold() {
    var el = document.querySelector(THRESHOLD_SELECTOR);
    if (el) {
      var text = el.textContent.trim();
      var value = parseAmount(text);
      if (value !== null) {
        lastThreshold = { text: text, value: value };
      }
    }
    return lastThreshold;
  }

  function readPrices(wrapper) {
    if (wrapper.freeShippingPrices) return wrapper.freeShippingPrices;
    var node = wrapper.querySelector('[data-free-shipping-prices]');
    var prices = {};
    if (node) {
      try {
        prices = JSON.parse(node.textContent) || {};
      } catch (error) {
        prices = {};
      }
    }
    wrapper.freeShippingPrices = prices;
    return prices;
  }

  function currentPrice(wrapper) {
    var scope = wrapper.closest('[data-section-id]') || document;
    var input = scope.querySelector(VARIANT_INPUT_SELECTOR);
    var variantId = input ? input.value || input.getAttribute('value') : null;
    var prices = readPrices(wrapper);

    if (variantId && prices[variantId] != null) {
      return prices[variantId] / 100;
    }

    var fallback = parseFloat(wrapper.getAttribute('data-default-price'));
    return isNaN(fallback) ? null : fallback / 100;
  }

  function render() {
    var wrappers = document.querySelectorAll('[data-free-shipping]');
    if (!wrappers.length) return false;

    var threshold = readThreshold();

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];
      var reached = wrapper.querySelector('[data-free-shipping-state="reached"]');
      var pending = wrapper.querySelector('[data-free-shipping-state="pending"]');
      var amount = wrapper.querySelector('[data-free-shipping-amount]');
      var price = currentPrice(wrapper);

      // if (!reached || !pending || !threshold || price === null) {
      //   wrapper.hidden = true;
      //   continue;
      // }

      if (!reached || !pending) {
        wrapper.hidden = true;
        continue;
      }

      if (!threshold || price === null) {
        wrapper.hidden = false;
        reached.hidden = false;
        pending.hidden = true;
        continue;
      }
      

      var isReached = price >= threshold.value;
      if (reached.hidden !== !isReached) reached.hidden = !isReached;
      if (pending.hidden !== isReached) pending.hidden = isReached;
      if (amount && amount.textContent !== threshold.text) {
        amount.textContent = threshold.text;
      }
      if (wrapper.hidden) wrapper.hidden = false;
    }

    return !!threshold;
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      watchVariantInputs();
      if (render()) {
        stopWatchingDom();
      } else {
        startWatchingDom();
      }
    });
  }

  // The AMP cart app mounts asynchronously and exposes no event we can wait on,
  // so on a cold load the threshold element does not exist yet. Watch for it,
  // then disconnect - on a warm cache this observer is never even constructed.
  function startWatchingDom() {
    if (domObserver || !document.body) return;
    domObserver = new MutationObserver(schedule);
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  function stopWatchingDom() {
    if (!domObserver) return;
    domObserver.disconnect();
    domObserver = null;
  }

  function watchVariantInputs() {
    var inputs = document.querySelectorAll(VARIANT_INPUT_SELECTOR);
    if (!inputObserver) inputObserver = new MutationObserver(schedule);
    for (var i = 0; i < inputs.length; i++) {
      if (watchedInputs.indexOf(inputs[i]) !== -1) continue;
      watchedInputs.push(inputs[i]);
      inputObserver.observe(inputs[i], { attributes: true, attributeFilter: ['value'] });
    }
  }
  document.addEventListener('change', schedule, true);
  if (window.Weglot && typeof window.Weglot.on === 'function') {
    window.Weglot.on('languageChanged', schedule);
  }

  window.freeShippingNotice = { refresh: schedule };
  schedule();
})();
